/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminInstrumentDto } from '../models/AdminInstrumentDto';
import type { CreateAdminInstrumentRequest } from '../models/CreateAdminInstrumentRequest';
import type { UpdateAdminInstrumentRequest } from '../models/UpdateAdminInstrumentRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminInstrumentsService {

  /**
   * @returns AdminInstrumentDto OK
   * @throws ApiError
   */
  public static listInstruments({
    companyKey,
    isActive,
  }: {
    companyKey?: string,
    isActive?: boolean,
  }): CancelablePromise<Array<AdminInstrumentDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/admin/instruments',
      query: {
        'companyKey': companyKey,
        'isActive': isActive,
      },
    });
  }

  /**
   * @returns AdminInstrumentDto OK
   * @throws ApiError
   */
  public static createInstrument({
    requestBody,
  }: {
    requestBody?: CreateAdminInstrumentRequest,
  }): CancelablePromise<AdminInstrumentDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/admin/instruments',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns AdminInstrumentDto OK
   * @throws ApiError
   */
  public static getInstrument({
    instrumentId,
  }: {
    instrumentId: string,
  }): CancelablePromise<AdminInstrumentDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/admin/instruments/{instrumentId}',
      path: {
        'instrumentId': instrumentId,
      },
    });
  }

  /**
   * @returns AdminInstrumentDto OK
   * @throws ApiError
   */
  public static updateInstrument({
    instrumentId,
    requestBody,
  }: {
    instrumentId: string,
    requestBody?: UpdateAdminInstrumentRequest,
  }): CancelablePromise<AdminInstrumentDto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v2/admin/instruments/{instrumentId}',
      path: {
        'instrumentId': instrumentId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
